/* 24 Oct 2026: the still-photo and reviewed-media replacement lists below were applied into inventory-data.js and are empty on purpose. */
/* TJS precise still batch4: product and exact gallery-field scoped. Model/hand/lifestyle, prices, variants and360state are excluded. */
const TJSProductStillBatch4=(()=>{
  'use strict';
  const operations=[];
  const byProduct=new Map();
  for(const op of operations.filter(o=>o.owner==='CATALOG')){
    if(!byProduct.has(op.productId))byProduct.set(op.productId,[]);
    byProduct.get(op.productId).push(op);
  }
  function forRecord(raw){
    if(!raw||typeof raw!=='object'||Array.isArray(raw))return raw;
    const ops=byProduct.get(raw.id);
    if(!ops)return raw;
    let result=raw;
    for(const op of ops){
      if(raw.sku!==op.stockId)continue;
      let current=raw;
      for(const key of op.path)current=current?.[key];
      if(current!==op.old)continue;
      if(result===raw)result={...raw};
      let target=result,original=raw;
      for(let i=0;i<op.path.length-1;i++){
        const key=op.path[i],nextOriginal=original[key];
        if(target[key]===nextOriginal)target[key]=Array.isArray(nextOriginal)?nextOriginal.slice():{...nextOriginal};
        target=target[key];original=nextOriginal;
      }
      target[op.path[op.path.length-1]]=op.url;
    }
    return result;
  }
  if(Array.isArray(window.TJS_INVENTORY_SEED))window.TJS_INVENTORY_SEED=window.TJS_INVENTORY_SEED.map(forRecord);
  for(const op of operations.filter(o=>o.owner==='meta')){
    const m=window.TJS_CATALOG_META?.[op.productId],v=m?.variants?.[Number(op.path[1])];
    if(!v||v.sku!==op.variantSku)continue;
    const imageIndex=Number(op.path[3]);
    if(v.images?.[imageIndex]===op.old)v.images[imageIndex]=op.url;
  }
  return {forRecord,revision:'2026-10-05-product-stills-batch4'};
})();
/* TJS studio still batch3: only 18 individually verified ring-only photos in model-labeled fields. Actual human/on-hand/lifestyle photos, prices, variants and 360 state are excluded. */
const TJSProductStillBatch3=(()=>{
  'use strict';
  const operations=[];
  const byProduct=new Map();
  for(const op of operations.filter(o=>o.owner==='CATALOG')){
    if(!byProduct.has(op.productId))byProduct.set(op.productId,[]);
    byProduct.get(op.productId).push(op);
  }
  function forRecord(raw){
    if(!raw||typeof raw!=='object'||Array.isArray(raw))return raw;
    const ops=byProduct.get(raw.id);
    if(!ops)return raw;
    let result=raw;
    for(const op of ops){
      if(raw.sku!==op.stockId)continue;
      let current=raw;
      for(const key of op.path)current=current?.[key];
      if(current!==op.old)continue;
      if(result===raw)result={...raw};
      let target=result,original=raw;
      for(let i=0;i<op.path.length-1;i++){
        const key=op.path[i],nextOriginal=original[key];
        if(target[key]===nextOriginal)target[key]=Array.isArray(nextOriginal)?nextOriginal.slice():{...nextOriginal};
        target=target[key];original=nextOriginal;
      }
      target[op.path[op.path.length-1]]=op.url;
    }
    return result;
  }
  if(Array.isArray(window.TJS_INVENTORY_SEED))window.TJS_INVENTORY_SEED=window.TJS_INVENTORY_SEED.map(forRecord);
  for(const op of operations.filter(o=>o.owner==='meta')){
    const m=window.TJS_CATALOG_META?.[op.productId];
    const seed=window.TJS_INVENTORY_SEED?.find(p=>p.id===op.productId&&p.sku===op.stockId);
    if(!m||!seed||op.path.length!==1||op.path[0]!=='model')continue;
    if(m.model===op.old)m.model=op.url;
  }
  return {forRecord,revision:'2026-10-05-product-studio-stills-batch3'};
})();
/* TJS precise still batch2: product and exact gallery-field scoped. Model/hand/lifestyle, prices, variants and360state are excluded. */
const TJSProductStillBatch2=(()=>{
  'use strict';
  const operations=[];
  const byProduct=new Map();
  for(const op of operations.filter(o=>o.owner==='CATALOG')){
    if(!byProduct.has(op.productId))byProduct.set(op.productId,[]);
    byProduct.get(op.productId).push(op);
  }
  function forRecord(raw){
    if(!raw||typeof raw!=='object'||Array.isArray(raw))return raw;
    const ops=byProduct.get(raw.id);
    if(!ops)return raw;
    let result=raw;
    for(const op of ops){
      if(raw.sku!==op.stockId)continue;
      let current=raw;
      for(const key of op.path)current=current?.[key];
      if(current!==op.old)continue;
      if(result===raw)result={...raw};
      let target=result,original=raw;
      for(let i=0;i<op.path.length-1;i++){
        const key=op.path[i],nextOriginal=original[key];
        if(target[key]===nextOriginal)target[key]=Array.isArray(nextOriginal)?nextOriginal.slice():{...nextOriginal};
        target=target[key];original=nextOriginal;
      }
      target[op.path[op.path.length-1]]=op.url;
    }
    return result;
  }
  if(Array.isArray(window.TJS_INVENTORY_SEED))window.TJS_INVENTORY_SEED=window.TJS_INVENTORY_SEED.map(forRecord);
  for(const op of operations.filter(o=>o.owner==='meta')){
    const m=window.TJS_CATALOG_META?.[op.productId],v=m?.variants?.[Number(op.path[1])];
    if(!v||v.sku!==op.variantSku)continue;
    const imageIndex=Number(op.path[3]);
    if(v.images?.[imageIndex]===op.old)v.images[imageIndex]=op.url;
  }
  return {forRecord,revision:'2026-10-05-product-stills-batch2'};
})();
/* TJS precise still batch1: product and exact gallery-field scoped. Model/hand/lifestyle, prices, variants and360state are excluded. */
const TJSProductStillBatch1=(()=>{
  'use strict';
  const operations=[];
  const byProduct=new Map();
  for(const op of operations.filter(o=>o.owner==='CATALOG')){
    if(!byProduct.has(op.productId))byProduct.set(op.productId,[]);
    byProduct.get(op.productId).push(op);
  }
  function forRecord(raw){
    if(!raw||typeof raw!=='object'||Array.isArray(raw))return raw;
    const ops=byProduct.get(raw.id);
    if(!ops)return raw;
    let result=raw;
    for(const op of ops){
      if(raw.sku!==op.stockId)continue;
      let current=raw;
      for(const key of op.path)current=current?.[key];
      if(current!==op.old)continue;
      if(result===raw)result={...raw};
      let target=result,original=raw;
      for(let i=0;i<op.path.length-1;i++){
        const key=op.path[i],nextOriginal=original[key];
        if(target[key]===nextOriginal)target[key]=Array.isArray(nextOriginal)?nextOriginal.slice():{...nextOriginal};
        target=target[key];original=nextOriginal;
      }
      target[op.path[op.path.length-1]]=op.url;
    }
    return result;
  }
  if(Array.isArray(window.TJS_INVENTORY_SEED))window.TJS_INVENTORY_SEED=window.TJS_INVENTORY_SEED.map(forRecord);
  for(const op of operations.filter(o=>o.owner==='meta')){
    const m=window.TJS_CATALOG_META?.[op.productId],v=m?.variants?.[Number(op.path[1])];
    if(!v||v.sku!==op.variantSku)continue;
    const imageIndex=Number(op.path[3]);
    if(v.images?.[imageIndex]===op.old)v.images[imageIndex]=op.url;
  }
  return {forRecord,revision:'2026-10-05-product-stills-batch1'};
})();
/* 5 Oct 2026: confirmed branded 360 viewers disconnected. Recoverable originals and evidence are retained in the TJS audit archive. Still-photo corrections below are unchanged. This is not a catalog-wide clearance. */
/* Reviewed product-media corrections, 4 Oct 2026. Original files retained.
   Scope: six BE2SF400 stills; one shared stud back photo; two confirmed branded
   rotations held with owner approval. This is NOT a catalog-wide clearance. */
const TJSReviewedMedia = (() => {
  const replacements={};
  const heldRotations=new Set();
  const resolve=value=>typeof value==='string'?(replacements[value]||value):value;
  function patch(value){
    if(!value||typeof value!=='object')return;
    for(const key of Object.keys(value)){
      const current=value[key];
      if(typeof current==='string')value[key]=key==='spin'&&heldRotations.has(current)?'':resolve(current);
      else patch(current);
    }
  }
  patch(window.TJS_INVENTORY_SEED);
  patch(window.TJS_CATALOG_META);
  // This imported "model" URL is actually a duplicate branded packshot,
  // not a person. Real hand/model photos remain in each variant gallery.
  for(const id of ['tjs-be2sf400','tjs-be204m']){
    if(!window.TJS_CATALOG_META?.[id])continue;
    window.TJS_CATALOG_META[id].model='';
    window.TJS_CATALOG_META[id].modelMetal='';
  }
  for(const id of ['tjs-be304rd0200lc','tjs-be304rd200','tjs-be304tcrd200']){
    for(const v of window.TJS_CATALOG_META?.[id]?.variants||[]){
      if(['White gold','Platinum'].includes(v.metal)&&!v.images.includes("https://cdn.shopify.com/s/files/1/0638/7836/5339/files/tjs-stud-2ct-white-back-unbranded.png?v=1791067596"))v.images.push("https://cdn.shopify.com/s/files/1/0638/7836/5339/files/tjs-stud-2ct-white-back-unbranded.png?v=1791067596");
    }
  }
  return {resolve,heldRotations:[...heldRotations],revision:'2026-10-05-confirmed-360-batch-6'};
})();
/* Shared, validated local inventory boundary. No API keys or private orders here.
   Production must replace this adapter with authenticated server-side services. */
const TJSInventory = (() => {
  'use strict';
  const key='tjs-inventory-v1', promoKey='tjs-promo-drafts-v1';
  const categories=['engagement','wedding','diamonds','earrings','necklaces','bracelets','mens-rings'];
  const metals=["White gold","Yellow gold","Rose gold","Platinum","Silver"];
  // Harsh approved all 12 items in the review PDF for retirement, 3 Oct 2026.
  // Keep the source records backed up; a stale browser import cannot restore them.
  // Entire Infinite Icon necklace retired at Harsh's request, 4 Oct 2026.
  // Jane Goodall Leaf bracelet retired at Harsh's request, 4 Oct 2026.
  // Jane Goodall Olive Branch bracelet retired at Harsh's request, 4 Oct 2026.
  // Five reviewed Jane Goodall products retired with Harsh's approval, 4 Oct 2026.
  // Remaining Jane Goodall collection retired at Harsh's request, 4 Oct 2026.
  // Explicit branded/collaboration collections retired at Harsh's request, 4 Oct 2026. Signature families retained.
  const retiredProductIds=new Set(["tjs-be1fm199","tjs-be1fm13","tjs-be1fm199h6","tjs-be1fm14","tjs-be1fm0126","tjs-be1fm01","tjs-be2d7858","tjs-be2fm16","tjs-be2fm30076","tjs-be2fm208","tjs-be2d7868","tjs-be2fm206","tjs-be2fm010","tjs-be27878","tjs-be2fm07","tjs-be2fm201","tjs-be2fm99","tjs-be3bd26lc","tjs-be3gd11lc","tjs-be3d615","tjs-be39878","tjs-be3gd27lc","tjs-be39880","tjs-be3d4189lc","tjs-be3gd22lc","tjs-be3d9647lc","tjs-be3bd33lc","tjs-be304rd100cclc","tjs-be3d768","tjs-be3gd32lc","tjs-be3d9214lc","tjs-be3lcbs41","tjs-be3fm07","tjs-be3dg2lc","tjs-be3lcrd25lc","tjs-be304rd200cclc","tjs-be3gd25lc","tjs-be3gd31lc","tjs-be3dpb4lc","tjs-be304rd150cclc","tjs-be3bd34lc","tjs-be3bd24lc","tjs-be3dpb7lc","tjs-be304rd75cclc","tjs-be304rd50cclc","tjs-be4dcc01lc","tjs-be4gd11lc","tjs-be4bd26lc","tjs-be4d631","tjs-be4gd4lc","tjs-be4d8796","tjs-be4d7351lc","tjs-be4dpb11lc","tjs-be4lcrd25lc","tjs-be4gd24lc","tjs-be4d734","tjs-be4gd20lc","tjs-be4d2825lc","tjs-be4d2716lc","tjs-be4d6666","tjs-be4fm05","tjs-be4d5656","tjs-be4pgd02lc","tjs-be4gd21lc","tjs-be4bd86lc","tjs-be4bd23lc","tjs-be4d8777","tjs-be7d3780lc","tjs-be41132","tjs-be4prc20","tjs-be4d831","tjs-be5dibm65","tjs-be5d2357","tjs-be5d2359","tjs-be5bd13lc","tjs-be565ie","tjs-be5d3156","tjs-be5gd10lc","tjs-be5d5412lc","tjs-be5dibc65","tjs-be5d2333","tjs-be5fmg28","tjs-be5lcbs178","tjs-be5d3111","tjs-be5dibv65","tjs-be5d6834lc","tjs-be565","tjs-be5bd11lc","tjs-be5diba65","tjs-be3d2159lc","tjs-be3d576lc","tjs-be3d821lc","tjs-be3d575lc","tjs-be3dcc1lc","tjs-be4d2158lc","tjs-be4d2159lc","tjs-be4d1405lc","tjs-be4d2578lc","tjs-be4d27789lc","tjs-be7d77lc","tjs-be4dcc9lc","tjs-be4dcc8lc","tjs-be4d2160lc","tjs-be4d58lc","tjs-be5d2162lc","tjs-be3d2158lc","tjs-be3d2258lc","tjs-be3dcc2lc","tjs-be3d531lc","tjs-be5d349lc","tjs-be5d487lc","tjs-be4dmjr1","tjs-be26137bc","tjs-be26138wc","tjs-be2619bm","tjs-be2bgt70","tjs-be2cgt60","tjs-be2d412","tjs-be2bdta600","tjs-be4cd5422","tjs-be5cd5485","tjs-be5cd5475","tjs-be5dwch1lc","tjs-be5wch2"]);
  const centerShapes=['Round','Princess','Asscher','Radiant','Cushion','Emerald','Marquise','Oval','Pear','Heart'];
  // The storefront and Catalog Desk share this schema. No specifications are
  // inferred from a photograph, category, or a competitor's product.
  const itemFieldSchema={
    engagement:[['width','Band width','number','mm'],['rhodium','Rhodium'],['settingType','Center setting type']],
    wedding:[['width','Band width','number','mm'],['thickness','Band thickness','number','mm'],['profile','Band profile'],['finish','Finish'],['rhodium','Rhodium']],
    'mens-rings':[['width','Band width','number','mm'],['thickness','Band thickness','number','mm'],['profile','Band profile'],['finish','Finish'],['rhodium','Rhodium']],
    earrings:[['width','Width','number','mm'],['length','Length','number','mm'],['backing','Backing type'],['closure','Closure'],['soldAs','Sold as']],
    necklaces:[['chainLength','Chain length (with unit)'],['chainType','Chain type'],['clasp','Clasp type'],['chainIncluded','Chain included'],['pendantDimensions','Pendant dimensions (with unit)']],
    bracelets:[['width','Width','number','mm'],['braceletLength','Bracelet length (with unit)'],['clasp','Clasp type'],['safetyClasp','Safety clasp'],['adjustability','Adjustability']]
  };
  const itemFieldsFor=category=>(itemFieldSchema[category]||[]).map(([key,label,type='text',unit=''])=>({key,label,type,unit}));
  const diamondFields=[['count','Number of diamonds','number',''],['totalCarat','Total carat weight','number','ctw'],['settingType','Setting type'],['shape','Shape'],['color','Color'],['clarity','Clarity'],['cut','Cut'],['origin','Diamond origin']].map(([key,label,type='text',unit=''])=>({key,label,type,unit}));
  const legacyDiamondFields={count:'sideStoneCount',totalCarat:'sideStoneCarat',settingType:'sideStoneSettingType',shape:'sideStoneShape',color:'sideStoneColor',clarity:'sideStoneClarity',cut:'sideStoneCut',origin:'sideStoneOrigin'};
  const diamondSpecsFor=product=>Object.fromEntries(diamondFields.map(f=>[f.key,product.category==='engagement'?product[legacyDiamondFields[f.key]]:Object.hasOwn(product.diamondDetails||{},f.key)?product.diamondDetails[f.key]:product[legacyDiamondFields[f.key]]]));
  // One metal registry serves every jewelry category; individual products keep
  // their own enabled metals, USD overrides and metal-specific photographs.
  const metalColors={'White gold':'#dddad5','Yellow gold':'#eed39d','Rose gold':'#dab19f',Platinum:'#c1c9ca',Silver:'#edf0f4'};
  const metalsForCategory=category=>{
    const products=records().filter(p=>p.status==='active'&&(category==='jewelry'?['earrings','necklaces','bracelets'].includes(p.category):p.category===category));
    return metals.filter(metal=>products.some(p=>p.metal.includes(metal)));
  };
  const safeText=(value,max=500)=>String(value??'').trim().slice(0,max);
  const safeUrl=value=>{
    const s=TJSReviewedMedia.resolve(safeText(value,1600));
    if(/^assets\/[a-zA-Z0-9_./%-]+$/.test(s)){try{const decoded=decodeURIComponent(s);if(!decoded.includes('..')&&!decoded.includes('\\')&&!decoded.includes('\u0000'))return s;}catch{}}
    try{const u=new URL(s);return u.protocol==='https:'&&!u.username&&!u.password?u.href:'';}catch{return '';}
  };
  const list=value=>Array.isArray(value)?value:String(value||'').split('|').map(s=>s.trim()).filter(Boolean);
  function validate(raw){raw=TJSProductStillBatch4.forRecord(raw);raw=TJSProductStillBatch3.forRecord(raw);raw=TJSProductStillBatch2.forRecord(raw);raw=TJSProductStillBatch1.forRecord(raw);
    const errors=[],p={};
    if(!raw||typeof raw!=='object'||Array.isArray(raw))return {errors:['Expected a product record.']};
    for(const [field,max] of [['id',80],['sku',100],['title',180],['category',30],['shape',40],['description',2500],['cut',50],['certification',50],['reportNumber',100],['polish',40],['symmetry',40],['fluorescence',50],['settingType',80],['sideStoneColor',40],['sideStoneClarity',40],['sourceStockId',100],['metalDescription',250],['sourceDescription',3000]])p[field]=safeText(raw[field],max);
    p.shopifyId=/^[1-9]\d*$/.test(String(raw.shopifyId??''))?String(raw.shopifyId):'';
    if(retiredProductIds.has(p.id))errors.push('This product has been retired from the TJS catalog.');
    if(!/^[a-zA-Z0-9][a-zA-Z0-9_-]*$/.test(p.id))errors.push('ID must use letters, numbers, dashes or underscores.');
    if(!p.sku)errors.push('SKU is required.');
    if(!p.title)errors.push('Product name is required.');
    if(!categories.includes(p.category))errors.push('Unknown category.');
    p.pricingStatus=raw.pricingStatus==='on-request'?'on-request':'priced';
    p.price=raw.price===''||raw.price==null?null:Number(raw.price);
    if(p.price!==null&&(!Number.isFinite(p.price)||p.price<=0))errors.push('Price must be a positive USD amount, or blank for price on request.');
    if(p.price===null&&p.pricingStatus!=='on-request')errors.push('A verified positive USD price is required.');
    if(p.price!==null)p.pricingStatus='priced';
    p.image=safeUrl(raw.image);if(!p.image)errors.push('Provide an HTTPS image URL or a local assets/ image.');
    p.images=[...new Set([p.image,...list(raw.images).map(safeUrl).filter(Boolean)])].filter(Boolean).slice(0,20);
    // Optional editorial/model photography. Blank records intentionally keep a
    // reserved gallery tile; never substitute unrelated campaign photographs.
    p.modelImages=[...new Set(list(raw.modelImages).map(safeUrl).filter(Boolean))].slice(0,4);
    p.baseKarat=['14K','18K'].includes(raw.baseKarat)?raw.baseKarat:'';
    // Imported supplier variants retain their own metal/karat price. No flat
    // upgrade rule may override an explicitly supplied variant matrix.
    p.metalVariants={};
    for(const [metal,variants] of Object.entries(raw.metalVariants||{})){
      if(!metals.includes(metal)||!Array.isArray(variants)){errors.push('Invalid metal variant group.');continue;}
      const grades=new Set();p.metalVariants[metal]=[];
      for(const v of variants){
        const grade=safeText(v.grade,30),price=Number(v.price),sku=safeText(v.sku,100);
        if(!['14K','18K','Platinum','Silver'].includes(grade)||!Number.isFinite(price)||price<=0||!sku||grades.has(grade)){errors.push('Invalid or repeated metal/karat variant.');continue;}
        grades.add(grade);p.metalVariants[metal].push({grade,price,sku});
      }
    }
    p.specificationText={};
    for(const field of ['width','count','totalCarat'])if(raw.specificationText?.[field])p.specificationText[field]=safeText(raw.specificationText[field],100);
    // TJS-approved defaults, 1 Oct 2026. Explicit null keeps an individual design quote-only.
    p.upgrade18kFee=null; // Retired: prices come from the exact metal variant, never a flat upgrade.
    if(p.upgrade18kFee!==null&&(!Number.isFinite(p.upgrade18kFee)||p.upgrade18kFee<0))errors.push('18K upgrade must be a non-negative USD amount or blank for a quote.');
    p.twoTonePrices={};
    for(const head of ['White gold','Yellow gold','Rose gold','Platinum','Silver']){
      const value=raw.twoTonePrices?.[head];
      if(value===undefined){p.twoTonePrices[head]=null;continue;}
      const fee=value===null||value===''?null:Number(value);
      if(fee!==null&&(!Number.isFinite(fee)||fee<0))errors.push('Two-tone surcharges must be non-negative USD amounts or blank for a quote.');
      else p.twoTonePrices[head]=fee;
    }
    p.twoToneAllowed=(raw.twoToneAllowed===true||raw.twoToneAllowed==='true')&&p.category==='engagement';
    p.metal=list(raw.metal).filter(m=>metals.includes(m));if(p.category!=='diamonds'&&!p.metal.length&&p.pricingStatus!=='on-request')errors.push('Provide at least one supported metal.');
    p.styles=list(raw.styles).filter(s=>/^[a-z0-9-]+$/.test(s)).slice(0,12);
    p.origin=raw.origin==='natural'?'natural':'lab-grown';
    if(p.category==='diamonds'&&!['natural','lab-grown'].includes(raw.origin))errors.push('Diamond origin must explicitly be natural or lab-grown.');
    p.color=safeText(raw.color,20);p.clarity=safeText(raw.clarity,20);
    for(const field of ['carat','depth','table','ratio','width','sideStoneCarat','sideStoneCount','minCarat','maxCarat','engravingFee']){
      const value=raw[field];p[field]=value===''||value==null?null:Number(value);
      if(p[field]!==null&&(!Number.isFinite(p[field])||p[field]<0))errors.push(field+' must be a non-negative number.');
    }
    if(p.sideStoneCount!==null&&!Number.isInteger(p.sideStoneCount))errors.push('Side-stone count must be a whole number.');
    if(p.category==='diamonds'&&(!p.carat||!p.shape||!p.color||!p.clarity))errors.push('Diamonds require carat, shape, color and clarity.');
    p.priceBasis=p.category==='diamonds'?'loose-diamond':p.category==='engagement'?(raw.priceBasis==='setting-component'?'setting-component':raw.priceBasis==='quote-required'?'quote-required':'complete-ring'):'item';
    p.reportUrl=safeUrl(raw.reportUrl);p.video=safeUrl(raw.video);
    p.compatibleShapes=list(raw.compatibleShapes).map(s=>safeText(s,40));
    // Per-design, per-shape approved limits. Empty is unknown, never an assumed fit.
    p.centerStoneRanges={};
    if(raw.centerStoneRanges!=null&&(typeof raw.centerStoneRanges!=='object'||Array.isArray(raw.centerStoneRanges)))errors.push('Center-stone ranges must be a shape map.');
    for(const [shape,range] of Object.entries(raw.centerStoneRanges||{})){
      if(!centerShapes.includes(shape)){errors.push('Unknown center-stone shape: '+safeText(shape,40));continue;}
      if(!range||typeof range!=='object'||Array.isArray(range)){errors.push(shape+': enter minimum and maximum carats.');continue;}
      const min=range.min==null||range.min===''?null:Number(range.min),max=range.max==null||range.max===''?null:Number(range.max);
      if(min===null&&max===null)continue;
      if(!Number.isFinite(min)||!Number.isFinite(max)||min<=0||max<=0||min>max){errors.push(shape+': provide positive minimum and maximum carats, with minimum no greater than maximum.');continue;}
      if(p.compatibleShapes.length&&!p.compatibleShapes.includes(shape)){errors.push(shape+': fitting limits conflict with supported shapes.');continue;}
      p.centerStoneRanges[shape]={min,max};
    }
    for(const name of ['rhodium','sideStoneSettingType','sideStoneShape','sideStoneCut','sideStoneOrigin'])p[name]=safeText(raw[name],100);
    p.itemDetails={};p.diamondDetails={};
    const detailSchema=[...new Map(categories.flatMap(itemFieldsFor).map(f=>[f.key,f])).values()];
    for(const [map,schema] of [['itemDetails',detailSchema],['diamondDetails',diamondFields]]){
      if(raw[map]!=null&&(typeof raw[map]!=='object'||Array.isArray(raw[map])))errors.push(map+' must be a field map.');
      for(const f of schema){
        if(!Object.hasOwn(raw[map]||{},f.key))continue;
        const value=raw[map][f.key];
        p[map][f.key]=f.type==='number'?(value==null||value===''?null:Number(value)):safeText(value,160);
        if(f.type==='number'&&p[map][f.key]!==null&&(!Number.isFinite(p[map][f.key])||p[map][f.key]<0))errors.push(f.label+' must be a non-negative number.');
      }
    }
    if(p.diamondDetails.count!=null&&!Number.isInteger(p.diamondDetails.count))errors.push('Number of diamonds must be a whole number.');
    p.diamondContent=['diamonds','none'].includes(raw.diamondContent)?raw.diamondContent:'unconfirmed';
    const stones=diamondSpecsFor(p);
    if(p.diamondContent==='none'&&(Number(stones.count)>0||Number(stones.totalCarat)>0))errors.push('No diamonds conflicts with the supplied diamond count or carat weight.');
    if(p.minCarat!==null&&p.maxCarat!==null&&p.minCarat>p.maxCarat)errors.push('Minimum fitting carat exceeds maximum.');
    p.quickShip=raw.quickShip===true||raw.quickShip==='true';
    // TJS policy approved 3 Oct 2026: engagement rings only, USD 30.
    p.engravingAllowed=p.category==='engagement';
    p.engravingFee=p.engravingAllowed?30:null;
    p.status=raw.status==='active'?'active':'draft';
    p.isDemo=raw.isDemo===true||raw.isDemo==='true';
    p.demoRevision=Number.isInteger(raw.demoRevision)?raw.demoRevision:0;
    p.metalOptionsRevision=Number.isInteger(raw.metalOptionsRevision)?raw.metalOptionsRevision:0;
    p.defaultMetal=p.metal.includes(raw.defaultMetal)?raw.defaultMetal:p.metal[0]||'';
    p.metalPrices={};
    for(const metal of p.metal){
      if(!Object.hasOwn(raw.metalPrices||{},metal))continue;
      const value=raw.metalPrices[metal],price=value==null||value===''?null:Number(value);
      if(price!==null&&(!Number.isFinite(price)||price<=0))errors.push('Metal prices must be positive USD amounts or blank for a quote.');
      else p.metalPrices[metal]=price;
    }
    p.metalImages={};
    for(const metal of p.metal){const urls=list(raw.metalImages?.[metal]).map(safeUrl).filter(Boolean).slice(0,12);if(urls.length)p.metalImages[metal]=[...new Set(urls)];}
    p.handle=p.id;p.source=safeText(raw.source||'TJS import',100);
    return {product:p,errors};
  }
  function rawRecords(){
    return [...(window.TJS_INVENTORY_SEED||[])];
  }
  function archivedBrowserRecords(){
    const merged=new Map((Array.isArray(window.TJS_INVENTORY_SEED)?window.TJS_INVENTORY_SEED:[]).map(p=>[p.id,p]));
    const retired=new Set(window.TJS_RETIRED_DEMO_IDS||[]);
    try{const local=JSON.parse(TJSPreview.storage.getItem(key));if(Array.isArray(local))local.forEach(p=>{
      if(!p||typeof p.id!=='string')return;
      if(retired.has(p.id)&&p.isDemo!==false)return;
      const seed=merged.get(p.id);
      // Upgrade earlier unpriced browser records once; preserve names and manual edits.
      if(seed?.demoRevision>Number(p.demoRevision||0)){
        p={...seed,...p,isDemo:true,demoRevision:seed.demoRevision,price:p.price??seed.price,pricingStatus:'priced',
          priceBasis:p.priceBasis==='quote-required'?seed.priceBasis:p.priceBasis||seed.priceBasis,
          metal:p.metal?.length?p.metal:seed.metal,metalImages:p.metalImages&&Object.keys(p.metalImages).length?p.metalImages:seed.metalImages,
          defaultMetal:p.defaultMetal||seed.defaultMetal,image:seed.image,
          engravingAllowed:seed.engravingAllowed,engravingFee:p.engravingFee??seed.engravingFee};
      }
      // Add only the newly approved seed preference; preserve saved edits and prices.
      if(seed?.metal?.includes('Silver')&&Object.hasOwn(seed.metalPrices||{},'Silver')&&Number(p.metalOptionsRevision||0)<1){
        p={...p,metal:[...new Set([...list(p.metal),'Silver'])],metalPrices:{Silver:seed.metalPrices.Silver,...p.metalPrices},metalOptionsRevision:1};
      }
      merged.set(p.id,p);
    });}catch{}return [...merged.values()];
  }
  function records(){const seen=new Set();return rawRecords().flatMap(raw=>{const result=validate(raw);if(result.errors.length||seen.has(result.product.id))return [];seen.add(result.product.id);return [result.product];});}
  function save(rows){const seen=new Set(),skus=new Set();const validated=rows.map(raw=>{const r=validate(raw);if(r.errors.length)throw new Error(r.errors.join(' '));if(seen.has(r.product.id))throw new Error('Duplicate product ID: '+r.product.id);if(skus.has(r.product.sku.toUpperCase()))throw new Error('Duplicate SKU: '+r.product.sku);seen.add(r.product.id);skus.add(r.product.sku.toUpperCase());return r.product;});TJSPreview.storage.setItem(key,JSON.stringify(validated));return validated;}
  function parseCSV(text){
    const rows=[];let row=[],field='',quoted=false;
    text=String(text).replace(/^\uFEFF/,'');
    for(let i=0;i<text.length;i++){const c=text[i];
      if(c==='"'){if(quoted&&text[i+1]==='"'){field+='"';i++;}else if(quoted)quoted=false;else if(!field)quoted=true;else throw new Error('Unexpected quote in CSV.');}
      else if(c===','&&!quoted){row.push(field);field='';}
      else if((c==='\n'||c==='\r')&&!quoted){if(c==='\r'&&text[i+1]==='\n')i++;row.push(field);if(row.some(v=>v.trim()))rows.push(row);row=[];field='';}
      else field+=c;
    }
    if(quoted)throw new Error('An unclosed quote was found in the CSV.');
    if(field||row.length){row.push(field);rows.push(row);}
    if(!rows.length)return [];
    const headers=rows.shift().map(s=>s.trim()),named=headers.filter(Boolean);
    if(new Set(named).size!==named.length||named.some(h=>['__proto__','constructor','prototype'].includes(h)))throw new Error('Invalid or repeated CSV columns.');
    return rows.map((values,index)=>{if(values.length!==headers.length)throw new Error('Column count mismatch at row '+(index+2));if(headers.some((h,i)=>!h&&values[i].trim()))throw new Error('An unnamed column contains data at row '+(index+2));return Object.fromEntries(headers.flatMap((h,i)=>h?[[h,values[i]]]:[]));});
  }
  function promos(){try{const data=JSON.parse(TJSPreview.storage.getItem(promoKey));return Array.isArray(data)?data.filter(p=>p&&typeof p.code==='string'&&/^[A-Z0-9_-]{3,30}$/.test(p.code)&&['percent','fixed'].includes(p.type)&&Number.isFinite(p.value)&&p.value>0&&(p.type!=='percent'||p.value<=100)).map(p=>({...p,status:'draft'})):[];}catch{return [];}}
  function savePromo(raw){
    const code=safeText(raw.code,30).toUpperCase(),value=Number(raw.value);
    if(!/^[A-Z0-9_-]{3,30}$/.test(code)||!Number.isFinite(value)||value<=0||(raw.type==='percent'&&value>100))throw new Error('Use a valid code and discount amount.');
    const item={code,type:raw.type==='percent'?'percent':'fixed',value,status:'draft',createdAt:new Date().toISOString()};
    TJSPreview.storage.setItem(promoKey,JSON.stringify([...promos().filter(p=>p.code!==code),item]));return item;
  }
  // Preserve earlier browser selections before retiring the old catalog. No broad reset.
  try{const archive='tjs-before-catalog-clear-20260923';if(!TJSPreview.storage.getItem(archive))TJSPreview.storage.setItem(archive,JSON.stringify({cart:TJSPreview.storage.getItem('tjs-cart-v2'),favorites:TJSPreview.storage.getItem('tjs-favorites-v2'),builder:TJSPreview.storage.getItem('tjs-builder-v2')}));}catch{}
  return {validate,parseCSV,records,save,promos,savePromo,safeUrl,products:()=>records().filter(p=>p.status==='active'&&!p.isDemo),categories,metals,metalColors,metalsForCategory,centerShapes,itemFieldsFor,diamondFields,legacyDiamondFields,diamondSpecsFor};
})();

/* Shopify is authoritative for publication, titles and variant prices.
 * Design/fit metadata and reviewed galleries remain legacy presentation data
 * until migrated; they cannot make an unpublished product visible. */
window.TJSShopifyCatalog=(()=>{
 'use strict';
 const state={phase:'loading',products:new Map(),checkedAt:null,error:null};
 const applyListeners=new Set();
 const read=doc=>{
  const el=doc.getElementById('tjs-shopify-public-catalog');
  if(!el)throw Error('Shopify catalog response unavailable');
  const data=JSON.parse(el.textContent);
  if(data.schema!==1||!Array.isArray(data.products)||!Number.isInteger(data.page)||!Number.isInteger(data.pages)||data.pages<0||data.pages>100)throw Error('Invalid Shopify catalog response');
  return data;
 };
 let inflight;
 async function collect(initial){
  const first=initial||await page(1),pages=Math.max(1,first.pages),rows=[...first.products];
  if(first.page!==1)throw Error('Unexpected Shopify catalog page');
  for(let n=2;n<=pages;n++){const next=await page(n);if(next.page!==n||Math.max(1,next.pages)!==pages)throw Error('Catalog changed during loading; retry');rows.push(...next.products);}
  const map=new Map();for(const p of rows){if(!p.handle||!p.id||!Array.isArray(p.variants)||map.has(p.handle))throw Error('Invalid or repeated Shopify product');map.set(p.handle,p);}
  return map;
 }
 async function page(number){
  const root=window.Shopify?.routes?.root||'/';
  const url=new URL(root,location.origin);url.searchParams.set('page',number);url.searchParams.set('tjs_catalog_refresh',Date.now());
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
  try{const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:controller.signal});if(!response.ok)throw Error('Shopify catalog request failed');return read(new DOMParser().parseFromString(await response.text(),'text/html'));}finally{clearTimeout(timer);}
 }
 function refresh(initial){
  if(inflight)return inflight;
  state.phase='loading';state.error=null;
  inflight=collect(initial).then(products=>{state.products=products;state.phase='ready';state.checkedAt=Date.now();},error=>{state.products=new Map();state.phase='error';state.error=error.message;console.warn('TJS Shopify catalog:',error.message);}).finally(()=>{inflight=null;for(const fn of applyListeners)fn();});
  return inflight;
 }
 let first;try{first=read(document);}catch(e){state.error=e.message;}
 const ready=refresh(first);
 return {state,ready,refresh:()=>refresh(),onChange:fn=>applyListeners.add(fn),published:handle=>state.phase==='ready'&&state.products.has(handle)};
})();
